import React from 'react';
import {Link} from 'react-router-dom';

import './painting.css';

const Painting = ({
  index,
  hoverBlock,
  stateID,
  reader,
  readerIsSmall,
  painting,
  readerName,
  painterName
}) => {
  const check = index + 1 === stateID;
  return (
    <Link
      className="painting"
      to={`/page/${index}`}
      onMouseEnter={() => hoverBlock(index + 1)}
      onMouseLeave={() => hoverBlock(0)}
      style={check ? {background: 'white'} : null}
    >
      <div
        className="painting__cover"
        style={check ? {backgroundColor: 'rgba(69, 69, 69, 0.4)'} : null}
      />
      <div
        className="painting__icon"
        style={check ? {backgroundColor: '#71a1b8'} : null}
      >
        <img src="./images/sound.svg" alt="Перейти к картине"/>
      </div>
      <div
        className="painting__image"
        style={{
          backgroundImage: `url(./images/readers/${reader})`,
          backgroundSize: check ? '110% 110%' : null,
        }}
      >
        <div className={"painting__text" + (readerIsSmall ? " painting__text_small" : "")} style={check ? {opacity: '1'} : null} dangerouslySetInnerHTML={{__html: readerName}} />
      </div>
      <div
        className="painting__image"
        style={{
          backgroundImage: `url(./images/painters/PAINTINGS_MINIATURE/${painting})`,
          backgroundSize: check ? '110% 110%' : null
        }}
      >
        <div className={"painting__text" + (readerIsSmall ? " painting__text_small" : "")} style={check ? {opacity: '1'} : null} dangerouslySetInnerHTML={{__html: painterName}} />
      </div>
    </Link>
  );
};

export default Painting;
